import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=7e91c778&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"
import style0 from "./Activity.vue?vue&type=style&index=0&id=7e91c778&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e91c778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e91c778')) {
      api.createRecord('7e91c778', component.options)
    } else {
      api.reload('7e91c778', component.options)
    }
    module.hot.accept("./Activity.vue?vue&type=template&id=7e91c778&scoped=true", function () {
      api.rerender('7e91c778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/components/Activity.vue"
export default component.exports